import { createRouter, createRoute, createRootRoute, redirect } from "@tanstack/react-router";
import Root from "./pages/Root";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import LeadsPage from "./pages/Leads";
import { requireAuth } from "./utils/authCheck";
import store from "./store/store";

const rootRoute = createRootRoute({ component: Root });

const dashboardRoute = createRoute({
  path: "/",
  component: Dashboard,
  getParentRoute: () => rootRoute,
  loader: requireAuth, // protected
});

const usersRoute = createRoute({
  path: "/users",
  component: Users,
  getParentRoute: () => rootRoute,
  loader: requireAuth, // protected
});

const settingsRoute = createRoute({
  path: "/settings",
  component: Settings,
  getParentRoute: () => rootRoute,
  loader: requireAuth, // protected
});

const leadsRoute = createRoute({
  path: "/leads",
  component: LeadsPage,
  getParentRoute: () => rootRoute,
  loader: requireAuth, // protected
});

const loginRoute = createRoute({
  path: "/login",
  component: Login,
  getParentRoute: () => rootRoute,
  loader: async () => {
    const state = store.getState();
    if (state.auth.user) {
      throw redirect({ to: "/" }); // already logged in
    }
  },
});

const routeTree = rootRoute.addChildren([
  dashboardRoute,
  usersRoute,
  settingsRoute,
  leadsRoute,
  loginRoute,
]);

export const router = createRouter({ routeTree });
